import React, { useState } from "react";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import styles from "./TinyMCEContentTable.module.css";
import MuiModal from "../../../muiComps/MuiModal";
import TinyMCEEditor from "../TinyMCEEditor";
// import { useMutation } from "@tanstack/react-query";
import { axiosConfig } from "../../../../axios/axiosConfig";
import toast from "react-hot-toast";
import ReactHotToaster from "../../../common/ReactHotToaster";
import {
  Box,
  IconButton,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";

const TinyMCEContentTable = ({
  tableRowData,
  userID,
  setOpenTinyEditor,
  setPopupContentList,
  editorRef,
}) => {
  const [isEditing, setIsEditing] = useState(false);
  const [fetchedContent, setfetchedContent] = useState({});
  console.log(tableRowData, "tableRowData")
  // delete content handler
  const deleteContent = async (content_id) => {
    // Show a confirmation dialog
    const confirmDelete = window.confirm(
      "Are you sure you want to delete this item?"
    );

    // If the user confirms the deletion
    if (confirmDelete) {
      try {
        const res = await axiosConfig({
          method: "delete",
          url: `appdashboard/popup_message?id=${content_id}`,
          data: {},
        });

        if (res.status === 200 || res.statusText === "OK") {
          toast.success("Item deleted successfully!");

          setPopupContentList((prevState) => {
            return prevState.filter((item) => item.id !== content_id);
          });
        }
      } catch (error) {
        toast.error(error?.response?.data?.response || "Something went wrong");
      }
    }
  };

  return (
    <Box
      sx={{
        background: "#fff",
        borderRadius: "12px",
        border: "1px solid #e2e8f0",
        boxShadow: "0 1px 6px rgba(0,0,0,0.07)",
        overflow: "hidden",
        mb: 3,
      }}
    >
      <Box sx={{ background: "#04343a", p: "12px 20px" }}>
        <Typography sx={{ color: "#fff", fontWeight: 600, fontSize: "14px" }}>
          Modal Content Table
        </Typography>
      </Box>
      <TableContainer component={Paper} elevation={0} sx={{ borderTop: "1px solid #eef2f7" }}>
        <Table>
          <TableHead>
            <TableRow>
              {["Title", "Screen", "Publish Date", "Audience", "Actions"].map((label) => (
                <TableCell
                  key={label}
                  sx={{
                    fontWeight: 700,
                    fontSize: "13px",
                    color: "#fff",
                    background: "#04343a",
                    borderBottom: "none",
                    padding: "12px 16px",
                  }}
                >
                  {label}
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {tableRowData && tableRowData.length > 0 ? (
              tableRowData.map((item) => {
                const formattedDate = new Date(item.created_at).toDateString();
                return (
                  <TableRow key={item.id} sx={{ "&:hover": { background: "#f0faf5" } }}>
                    <TableCell>
                      <Typography sx={{ fontWeight: 600, color: "#016551", fontSize: "14px" }}>
                        {item?.title}
                      </Typography>
                    </TableCell>
                    <TableCell sx={{ color: "#64748b", fontSize: "13px" }}>{item?.screen_name}</TableCell>
                    <TableCell sx={{ color: "#64748b", fontSize: "13px", whiteSpace: "nowrap" }}>{formattedDate}</TableCell>
                    <TableCell sx={{ color: "#64748b", fontSize: "13px" }}>{item.user_type}</TableCell>
                    <TableCell>
                      <IconButton
                        onClick={() => {
                          setOpenTinyEditor(false);
                          setfetchedContent(item);
                          setIsEditing(true);
                        }}
                        sx={{ color: "#04343a" }}
                        title="Edit"
                      >
                        <EditIcon />
                      </IconButton>
                      <IconButton
                        onClick={() => deleteContent(item.id)}
                        sx={{ color: "#e53935" }}
                        title="Delete"
                      >
                        <DeleteIcon />
                      </IconButton>
                    </TableCell>
                  </TableRow>
                );
              })
            ) : (
              <TableRow>
                <TableCell colSpan={5} align="center" sx={{ py: 5, color: "#94a3b8" }}>
                  No modal content available.
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </TableContainer>

      {/* TinyMCE Modal Popup */}
      <MuiModal open={isEditing} setOpen={setIsEditing}>
        <TinyMCEEditor
          selectedScreen={fetchedContent.screen_name}
          screenContent={fetchedContent.screen_content}
          activeContent={fetchedContent}
          userID={userID}
          crudType="edit"
          editorRef={editorRef}
          setOpen={setIsEditing}
          setPopupContentList={setPopupContentList}
        />
      </MuiModal>

      {/* REACT HOT TOAST */}
      <ReactHotToaster />
    </Box>
  );
};

export default TinyMCEContentTable;

//
